/* eslint-disable */
import { useState, useEffect, useRef } from "react";
import { utility } from "../../../framework/utility/utilityProvider";
import { TouramentCard } from "./touramentCard";
import * as API from "../../../framework/API/api";
import _ from "underscore";
import AddRoundButton from "../../../framework/forms/helpercomponents/buttons/AddRoundButton";
import { TournamentEditForm } from "./TournamentEditForm";
import { ENTITYNAME, LIVE_EVENT_GENDER, TOAST_TYPES } from "../../../framework/constant/constant";
import RefreshButton from "../../../framework/forms/helpercomponents/buttons/RefreshButton";
import ActionButton from "../../../framework/forms/helpercomponents/buttons/ActionButton";
import SportsEventEditForm from "../SportsEventEditForm";
import ToastNotification from "../../../components/ToastNotification";
import { useTranslation } from "../../../locale/useTranslation";
import { useParams, useNavigate } from "react-router-dom";



export const TournamentList = (props) => {

  const lang = useTranslation();
  const { tournamentId } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const orginalData = useRef([]);
  const tournament = useRef({ SID: 0 });
  const setTournament = (data) => {
    tournament.current = data;
  }
  const [showTournament, setShowTournament] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [showSportsEventForm, setShowSportsEventForm] = useState(false);


  useEffect(() => {
    loadData();
  }, [tournamentId])

  const loadData = async () => {

    setSearchText('');
    setIsLoading(true);
    var res = await API.getLiveEventsTournamentData(tournamentId);
    setIsLoading(false);
    // console.log(res.data);

    if (res.data.length > 0) {
      orginalData.current = res.data;

      let selectedItem = res.data[0];
      if (tournamentId) {
        const found = res.data.find(t => t._id === tournamentId);
        if (found) {
          selectedItem = found;
        }
      }

      const updatedData = res.data.map(item => ({
        ...item,
        isSelected: item._id === selectedItem._id
      }));

      setData(updatedData);
      props.onSelection(selectedItem);
    }
  }

  const onSelection = (index, dataItem) => {
    var copyData = [...data];
    resetSelection(copyData);
    copyData[index] = { ...Object.assign(dataItem, { isSelected: true }) };
    setData(copyData);
    props.onSelection(dataItem);
  }

  const resetSelection = (copyData) => {
    copyData.map((dataItem) => {
      Object.assign(dataItem, { isSelected: false });
    });
  };


  const onSearch = (e) => {

    if (orginalData.current.length == 0) return;

    const keyword = e.target.value?.trim();
    setSearchText(keyword);
    var datakey = Object.keys(orginalData.current[0]);


    var dataStore = [];
    if (keyword != "") {
      datakey.map((item) => {
        var filterData = orginalData.current.filter((obj) => obj[item] && _.isString(obj[item]) && obj[item].toLowerCase().includes(keyword.toLowerCase()));
        if (filterData.length != 0) {
          dataStore.push(...filterData);
        }
      });
      const uniqData = [...new Set(dataStore)];
      setData(uniqData);
      resetSelection(uniqData);
    } else {
      setData(orginalData.current);
      resetSelection(orginalData.current);
      // If the text field is empty, show all users
    }

  };

  const refreshData = (dataItem) => {

    //SELECT NEW ADDED OR UPDATED AND DE-SELECT OTHER
    let localData = data && data.length > 0 ? data.map((x) => {
      delete x.isSelected
      return x
    }) : []
    dataItem = { ...dataItem, isSelected: true };
    var index = localData.findIndex((x) => x.SID == dataItem.SID);

    if (index < 0) {
      setData([...localData, dataItem]);
      return;
    }

    var gridData = [...localData];
    gridData[index] = dataItem;

    setData(gridData);
    props.onSelection(dataItem);

  }

  const onAddTournament = () => {
    console.log('here')
    setTournament({ SID: 0 });
    setShowTournament(true);
  }

  const deleteTournament = (index, dataItem) => {
    console.log(index);
    // SetOttAssets(old => old.filter((item, i) => {
    //   return index !== i;
    // }))
    // if (dataItem.SID !== 0) {
    //   setDeleteOttAssetsSID(old => [...old, dataItem.SID])
    // }
    // ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `${lang.delete_successfully_grid_data_success_toast_message}` });
  }

  const editTournament = (index, dataItem) => {
    setShowTournament(true);

    dataItem.isSelected && delete dataItem.isSelected;
    setTournament(dataItem);
  }

  const handleSportEventList = (item) => {
    setTournament({ SID: 0, ...item });
    setShowTournament(true);
  }

  const selectedTournament = tournamentId ? data.find((t) => t._id === tournamentId) : null;

  if (tournamentId && !isLoading) {
    if (!selectedTournament) {
      return (
        <div
          className="side-bar-items marlr p-3 text-center"
          style={{
            height: "100%",
            maxHeight: "calc(100vh - 120px)",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            backgroundColor: "#ffffff",
            borderRadius: "8px",
            border: "1px solid #e3e6f0",
            boxShadow: "0 2px 4px rgba(0,0,0,0.04)"
          }}
        >
          <i className="fa fa-exclamation-circle text-warning" style={{ fontSize: "40px" }}></i>
          <h4 style={{ color: "#5a5c69", margin: 0, fontWeight: "600" }}>No tournament found</h4>
          <button className="btn btn-sm btn-outline-primary mt-2" style={{ borderRadius: "20px" }} onClick={() => navigate(-1)}>
            <i className="fa fa-arrow-left mr-1" style={{ marginRight: '5px' }}></i> Back to List
          </button>
        </div>
      );
    }

    return (
      <div
        className="side-bar-items marlr p-3"
        style={{
          height: "100%",
          maxHeight: "calc(100vh - 120px)",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          border: "1px solid #e3e6f0",
          boxShadow: "0 2px 4px rgba(0,0,0,0.04)"
        }}
      >
        {/* Breadcrumb / Back button */}
        <div
          className="d-flex align-items-center cursor-pointer text-primary"
          style={{ fontSize: "14px", fontWeight: "600", gap: "8px" }}
          onClick={() => navigate(-1)}
        >
          <i className="fa fa-chevron-left"></i>
          <span>Tournaments / {utility.subString(selectedTournament.Name, 18)}</span>
        </div>

        {/* Poster Image */}
        <div className="text-center">
          <img
            src={selectedTournament.PosterUrl || "https://i.postimg.cc/j5PsF5jZ/defaultmovie.png"}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "https://i.postimg.cc/j5PsF5jZ/defaultmovie.png";
            }}
            style={{
              width: "100%",
              maxHeight: "260px",
              objectFit: "cover",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
            }}
            alt={selectedTournament.Name}
          />
        </div>

        {/* Info Area */}
        <div>
          <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#2c3e50", marginBottom: "6px" }}>
            {selectedTournament.Name}
          </h2>
          <span
            className="badge"
            style={{
              backgroundColor: "#6c5ce7",
              color: "white",
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "11px",
              fontWeight: "600"
            }}
          >
            {selectedTournament.TournamentType?.Description || "Tournament"}
          </span>
        </div>

        {/* Actions */}
        <div className="d-flex flex-column" style={{ gap: "8px" }}>
          <button
            className="btn btn-primary w-100"
            style={{
              backgroundColor: "#4e73df",
              borderColor: "#4e73df",
              padding: "8px",
              fontWeight: "600",
              fontSize: "14px",
              borderRadius: "6px"
            }}
            onClick={() => editTournament(data.findIndex(t => t._id === tournamentId), selectedTournament)}
          >
            Edit tournament
          </button>
          <button
            className="btn btn-outline-secondary w-100"
            style={{
              padding: "8px",
              fontWeight: "600",
              fontSize: "14px",
              borderRadius: "6px",
              backgroundColor: "white",
              border: "1px solid #ced4da",
              color: "#5a5c69"
            }}
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
        </div>

        {/* Metadata Details */}
        <div className="border-top pt-3" style={{ fontSize: "13px", color: "#4e5154" }}>
          <div className="mb-2">
            <div style={{ fontSize: "10px", color: "#95a5a6", textTransform: "uppercase", fontWeight: "700", letterSpacing: "0.5px" }}>Event Duration</div>
            <div style={{ color: "#2c3e50", fontWeight: "500" }}>
              {utility.datetimeFormatV2(selectedTournament.StartDate)} - {utility.datetimeFormatV2(selectedTournament.EndDate)}
            </div>
          </div>

          <div className="mb-2">
            <div style={{ fontSize: "10px", color: "#95a5a6", textTransform: "uppercase", fontWeight: "700", letterSpacing: "0.5px" }}>Channels</div>
            <div style={{ color: "#2c3e50", fontWeight: "500" }}>
              {utility.displayArrayInPipe(selectedTournament.Channels, "FullChannelName") || "None"}
            </div>
          </div>

          <div className="mb-2">
            <div style={{ fontSize: "10px", color: "#95a5a6", textTransform: "uppercase", fontWeight: "700", letterSpacing: "0.5px" }}>Tournament ID</div>
            <div style={{ color: "#2c3e50", fontWeight: "500" }}>{selectedTournament.TournamentID || "N/A"}</div>
          </div>
          <div className="mb-2">
            <div style={{ fontSize: "10px", color: "#95a5a6", textTransform: "uppercase", fontWeight: "700", letterSpacing: "0.5px" }}>Type</div>
            <div style={{ color: "#2c3e50", fontWeight: "500" }}>{selectedTournament.TournamentType?.Description || "Tournament"}</div>
          </div>
          <div className="mb-2">
            <div style={{ fontSize: "10px", color: "#95a5a6", textTransform: "uppercase", fontWeight: "700", letterSpacing: "0.5px" }}>Gender</div>
            <div style={{ color: "#2c3e50", fontWeight: "500" }}>{utility.getKeyByValue(LIVE_EVENT_GENDER, selectedTournament.Gender) || "N/A"}</div>
          </div>
          <div className="mt-3">
            <div style={{ fontSize: "10px", color: "#95a5a6", textTransform: "uppercase", fontWeight: "700", letterSpacing: "0.5px", marginBottom: "6px" }}>Country</div>
            <div className="d-flex flex-wrap" style={{ gap: "6px" }}>
              <span style={{ backgroundColor: "#eaecf4", color: "#5a5c69", padding: "4px 8px", borderRadius: "4px", fontSize: "11px" }}>
                {selectedTournament?.EventCountry || "N/A"}
              </span>
            </div>
          </div>
          <div className="mt-3">
            <div style={{ fontSize: "10px", color: "#95a5a6", textTransform: "uppercase", fontWeight: "700", letterSpacing: "0.5px", marginBottom: "6px" }}>Tags</div>
            <div className="d-flex flex-wrap" style={{ gap: "6px" }}>
              <span style={{ backgroundColor: "#eaecf4", color: "#5a5c69", padding: "4px 8px", borderRadius: "4px", fontSize: "11px" }}>
                {selectedTournament.TournamentType?.Description || "Sports"}
              </span>
              {selectedTournament.Channels?.map((ch, idx) => (
                <span key={idx} style={{ backgroundColor: "#eaecf4", color: "#5a5c69", padding: "4px 8px", borderRadius: "4px", fontSize: "11px" }}>
                  {ch.FullChannelName}
                </span>
              ))}
            </div>
          </div>
        </div>

        {showTournament && (
          <TournamentEditForm
            title={"Tournament"}
            entityName={ENTITYNAME.Tournament}
            item={tournament.current}
            refresh={refreshData}
            cancelEdit={() => setShowTournament(false)}
          />
        )}
      </div>
    );
  }

  return (
    <div className="side-bar-items marlr p-1">

      {/* title */}
      <div>
        <h1 className="page-title txt-color-bludeDark" style={{ margin: '10px 5px' }}>
          <i className="fa fa-table marlr" style={{ fontSize: "20px", color: "GrayText" }} ></i>
          <span className="h1" style={{ letterSpacing: '0.1px' }}>Tournaments</span>
        </h1>
      </div>

      {/* search */}
      <div className="col-12 mb-2">
        <div className="input-group input-group w-300 ">
          <input
            type="text"
            className="form-control shadow-inset-2 pt-0 pb-0"
            id="filter-icon"
            aria-label="type 2 or more letters"
            placeholder={"Search"}
            onChange={onSearch}
            value={searchText}
          />

          <div className="input-group-append">
            <span className="input-group-text">
              <i style={{ margin: "4px 0px" }} className="fa fa-search" />
            </span>
          </div>
        </div>

      </div>

      <div className="flex-container p-2">
        <AddRoundButton title={'Add Tournament'} name={'Add Tournament'} onClick={onAddTournament} />
        <RefreshButton onClick={loadData} />
        <div className="flex-container-reverse flex-item-auto">
          <span
            className='float-right cursor-pointer'
            style={{
              backgroundColor: 'grey',
              margin: "5px 0px",
              color: 'white',
              padding: '4px',
              border: '1px solid #ced4da',
              fontSize: '10px'
            }}
            onClick={() => { setShowSportsEventForm(true) }}
          >
            {"Sports"}
          </span>


        </div>
      </div>

      {/* card starting */}
      {isLoading ?
        // loading
        <div className="ml-2 mt-2">
          <i style={{ fontSize: "20px", color: "GrayText" }} className="fas fa-spinner fa-pulse"></i>
        </div>
        :
        <div style={{ height: props.height ?? "68vh", overflowY: "auto", overflowX: "hidden" }}>

          {
            data.map((tournamentData, index) => {
              return (
                <TouramentCard id={tournamentData._id} tournamentData={tournamentData} onSelection={onSelection} index={index} onEditDataItem={editTournament} onDeleteDataItem={deleteTournament} />
              );
            })
          }

        </div>

      }

      {showTournament && <TournamentEditForm title={'Tournament'} entityName={ENTITYNAME.Tournament} item={tournament.current} refresh={refreshData} cancelEdit={() => setShowTournament(false)} />}
      {showSportsEventForm && <SportsEventEditForm mediaCategory={props.mediaCategory} cancelEdit={() => setShowSportsEventForm(false)} sportsTournamentList={handleSportEventList} />}

    </div>
  )
}